import React from "react";

export default function TequilaFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-teq31{fill:#a8b6c1}.cls-teq32{fill:#e5981c}.cls-teq33{fill:#f7d78f}.cls-teq34{fill:#fcc977}.cls-teq35{fill:#e4eaef}.cls-teq36{fill:#d13920}.cls-teq37{fill:#e87f38}.cls-teq38{fill:#f7be59}.cls-teq39{fill:#f7af31}.cls-teq310{fill:#f0f4f7}.cls-teq311{fill:#cad3db}.cls-teq313{fill:#ea5436}"
            }
          </style>
        </defs>
        <path
          d="M1571.32 1892.02H555.98c-83.85 0-152.07-68.22-152.07-152.07V724.61c0-83.85 68.22-152.07 152.07-152.07h1015.34c83.85 0 152.07 68.22 152.07 152.07v1015.34c0 83.85-68.22 152.07-152.07 152.07ZM555.97 612.54c-61.79 0-112.07 50.27-112.07 112.07v1015.34c0 61.79 50.27 112.07 112.07 112.07h1015.34c61.79 0 112.07-50.27 112.07-112.07V724.61c0-61.79-50.27-112.07-112.07-112.07H555.97Z"
          className="cls-teq37"
        />
        <path
          d="M1463.98 578.77c-29.59 27.69-57.55 53.37-102.3 70.21-32.98 12.4-57.87 13.54-153.51 14.06-117.68.63-153.38-.03-153.38-.03-222.48-4.12-255.02-6.27-296.87-32.09-33.9-20.94-84.51-63.95-76.48-93.37.08-.3.17-.6.26-.9 1.11-3.5 3.01-6.6 5.64-9.32 26.08-27.06 124.02-18.44 235.5-18.42 11.76 0 23.66-.09 35.65-.34 259.09-5.24 444.37-77.17 541.91-100.99h.01l.05-.01c.01 0 .04-.01.07-.01 41.53-10.13 67.14-11.51 75.75 4.74 21.71 41.01-90.31 145.87-112.32 166.48Z"
          className="cls-teq32"
        />
        <path
          d="M1280.1 600.16H894.46L940.25 449l7.24-23.92 2.93-9.68 5.91-19.47 11.64-38.44 12.22-40.33 7.31-24.12 12.27-40.51 1.89-6.19 5.76-19.04 1.86-6.14 5.96-19.68 1.89-6.19 23.42-77.33c14.01-46.25 79.49-46.25 93.5 0l22.31 73.64 2 6.64 6.53 21.58 2.12 6.99 6.52 21.51 2 6.65 14.63 48.26 9.17 30.23 1.95 6.44 15.59 51.47 12.03 39.73 9.85 32.54 41.36 136.53Z"
          className="cls-teq38"
        />
        <path
          d="M1281.11 600.16h-73.55l-146.08-482.21c-2.19-7.24-5.64-13.34-9.98-18.32 23.28-26.79 71.7-20.69 83.52 18.32l146.08 482.21Z"
          className="cls-teq39"
        />
        <path
          d="M1199.32 333.46c-17.44-1.44-20.49-18.4-41.62-18.4-23.48 0-23.48 18.33-46.94 18.33-23.46 0-23.46-18.33-46.93-18.33-23.48 0-23.48 18.33-46.94 18.33-19.86 0-22.3-11.21-36.7-16.24l7.31-24.12c8.45 5.47 14.32 14.08 29.38 14.08 23.46 0 23.46-18.33 46.94-18.33 23.46 0 23.46 18.33 46.93 18.33 23.48 0 23.48-18.33 46.94-18.33 17.75 0 21.58 8.96 32.47 14.44l9.17 30.23Z"
          className="cls-teq313"
        />
        <path
          d="M1167 226.8c-5.66-1.23-11-2.63-21.75-2.63-20.27 0-20.27 4.37-40.52 4.37-20.26 0-20.26-4.37-40.51-4.37-20.27 0-20.27 4.37-40.54 4.37-7.69 0-12.35-.54-16.28-1.24l1.86-6.14c3.72.64 8.14 1.11 14.42 1.11 20.26 0 20.26-4.36 40.52-4.36s20.26 4.36 40.51 4.36c20.27 0 20.27-4.36 40.52-4.36 9.98 0 14.85.9 19.64 1.9l2.12 6.99ZM1175.53 254.96c-10.44-1.06-14.59-4.05-30.27-4.05-20.27 0-20.27 4.37-40.52 4.37-20.26 0-20.26-4.37-40.51-4.37-20.27 0-20.27 4.37-40.54 4.37-12.87 0-17.27-1.51-23.92-2.76l1.89-6.19c5.76 1.23 11.09 2.68 22.04 2.68 20.26 0 20.26-4.37 40.52-4.37s20.26 4.37 40.51 4.37c20.27 0 20.27-4.37 40.52-4.37 15.33 0 18.63 2.13 28.03 3.44l.25.22 2 6.65ZM1158.35 198.23c-3.31-.47-7.23-.8-12.41-.8-20.27 0-20.27 4.37-40.52 4.37-20.26 0-20.26-4.37-40.51-4.37-20.27 0-20.27 4.37-40.52 4.37-3.65 0-6.63-.12-9.15-.33l1.89-6.19c2.13.16 4.52.25 7.25.25 20.26 0 20.26-4.37 40.52-4.37s20.26 4.37 40.51 4.37c20.27 0 20.27-4.37 40.54-4.37 4.27 0 7.61.17 10.41.43l2 6.64Z"
          className="cls-teq33"
        />
        <path
          d="M1238.74 463.63c-16.92-5.58-23.56-20.05-49.58-20.05-33.95 0-33.95 22.05-67.92 22.05-33.95 0-33.95-22.05-67.9-22.05-33.96 0-33.96 22.05-67.93 22.05-24.41 0-30.89-10.02-45.16-16.64l7.24-23.92c10.03 6.38 18.67 14.28 37.91 14.28 33.96 0 33.96-22.06 67.92-22.06s33.96 22.06 67.92 22.06 33.96-22.06 67.93-22.06c21.11 0 28.81 7.49 39.74 13.8l9.85 32.54Z"
          className="cls-teq313"
        />
        <path
          d="M1216.86 391.37c-5.59-3.29-12.22-5.56-21-5.56-33.3 0-33.3 28.33-66.59 28.33-33.3 0-33.3-28.33-66.59-28.33-33.3 0-33.3 28.33-66.59 28.33-21.63 0-28.53-9.98-39.75-18.21l11.64-38.44c7.12 5.7 15.33 10.51 28.1 10.51 33.3 0 33.3-28.33 66.59-28.33 33.3 0 33.3 28.33 66.58 28.33 33.31 0 33.31-28.33 66.61-28.33 1.92 0 3.72.08 5.42.24l15.59 51.47Z"
          className="cls-teq37"
        />
        <path
          d="M1463.98 578.77c-29.59 27.69-57.55 53.37-102.3 70.21-32.98 12.4-57.87 13.54-153.51 14.06-117.68.63-153.38-.03-153.38-.03-222.48-4.12-255.02-6.27-296.87-32.09-33.9-20.94-84.51-63.95-76.48-93.37 1.74-3.57 3.72-6.98 5.91-10.23 26.08-27.06 124.02-18.44 235.5-18.42l-21.51 72.87c195.5 4.93 339.31-32.05 433.26-66.19 69.89-25.4 204.36-82.72 198.76-101.62-1.84-6.21-18.36-6.9-32.81-6.41 41.53-10.13 67.14-11.51 75.75 4.74 21.71 41.01-90.31 145.87-112.32 166.48Z"
          className="cls-teq39"
        />
        <path
          d="M901.34 581.77c-56.14-5.08-99.78-16.72-130.38-27.08-18.04-6.11-49.42-16.9-48.25-24.86 1.05-7.09 27.38-8.37 58.28-10.24 33.68-2.04 81.68-5.33 141.11-10.7-6.92 24.29-13.84 48.59-20.77 72.88Z"
          className="cls-teq32"
        />
        <path
          d="M1500.43 407.56h.05l-.07.01h.01Z"
          style={{
            fill: "#edab35",
          }}
        />
        <circle cx={680.59} cy={569.82} r={30.34} className="cls-teq313" />
        <path
          d="M710.93 569.82c0 16.76-13.58 30.34-30.34 30.34-2.62 0-5.15-.33-7.57-.96 13.08-3.37 22.76-15.24 22.76-29.38 0-14.14-9.68-26.02-22.76-29.38 2.42-.63 4.95-.96 7.57-.96 16.76 0 30.34 13.58 30.34 30.34Z"
          className="cls-teq36"
        />
        <circle cx={822.39} cy={655.32} r={30.34} className="cls-teq313" />
        <path
          d="M852.73 655.32c0 16.76-13.58 30.34-30.34 30.34-2.62 0-5.15-.33-7.57-.96 13.08-3.37 22.76-15.24 22.76-29.38 0-14.14-9.68-26.02-22.76-29.38 2.42-.63 4.95-.96 7.57-.96 16.76 0 30.34 13.58 30.34 30.34Z"
          className="cls-teq36"
        />
        <circle cx={1047.12} cy={674.54} r={30.34} className="cls-teq313" />
        <path
          d="M1077.46 674.54c0 16.76-13.58 30.34-30.34 30.34-2.62 0-5.15-.33-7.57-.96 13.08-3.37 22.76-15.24 22.76-29.38 0-14.14-9.68-26.02-22.76-29.38 2.42-.63 4.95-.96 7.57-.96 16.76 0 30.34 13.58 30.34 30.34Z"
          className="cls-teq36"
        />
        <circle cx={1255.64} cy={668.61} r={30.34} className="cls-teq313" />
        <path
          d="M1285.98 668.61c0 16.76-13.58 30.34-30.34 30.34-2.62 0-5.15-.33-7.57-.96 13.08-3.37 22.76-15.24 22.76-29.38 0-14.14-9.68-26.02-22.76-29.38 2.42-.63 4.95-.96 7.57-.96 16.76 0 30.34 13.58 30.34 30.34Z"
          className="cls-teq36"
        />
        <circle cx={1447.41} cy={600.16} r={30.34} className="cls-teq313" />
        <path
          d="M1477.75 600.16c0 16.76-13.58 30.34-30.34 30.34-2.62 0-5.15-.33-7.57-.96 13.08-3.37 22.76-15.24 22.76-29.38 0-14.14-9.68-26.02-22.76-29.38 2.42-.63 4.95-.96 7.57-.96 16.76 0 30.34 13.58 30.34 30.34Z"
          className="cls-teq36"
        />
        <circle cx={1566.62} cy={458.41} r={30.34} className="cls-teq313" />
        <path
          d="M1596.96 458.42c0 16.76-13.58 30.34-30.34 30.34-2.62 0-5.15-.33-7.57-.96 13.08-3.37 22.76-15.24 22.76-29.38 0-14.14-9.68-26.02-22.76-29.38 2.42-.63 4.95-.96 7.57-.96 16.76 0 30.34 13.58 30.34 30.34Z"
          className="cls-teq36"
        />
        <path
          d="m448.08 1773.43 128.68 40.18c10.2 3.18 21.06-2.35 24.5-12.46a2105.3 2105.3 0 0 1 27.19-75.26c22.05-57.6 45.42-111.05 69.13-160.31l-211.84-66.15c-7.35 54.6-17.59 112.91-31.7 174.21-6.01 26.12-12.4 51.39-19.07 75.8-2.8 10.23 3 20.83 13.11 23.99Z"
          className="cls-teq311"
        />
        <path
          d="M591.87 1795.44c7.51-3.64 12.59-8.75 15.61-12.33-2.1 6.01-4.17 11.99-6.19 17.93-3.44 10.11-14.31 15.65-24.5 12.46l-128.68-40.18c-10.12-3.16-15.91-13.76-13.11-23.99 2.08-7.61 4.13-15.31 6.16-23.09-1.11 5.78-1.8 14.32 1.92 22.77 6.79 15.44 22.63 17.65 67.29 31.73 48.89 15.42 63.58 23.39 81.51 14.69Z"
          className="cls-teq31"
        />
        <path
          d="m460.25 1750.16 119.44 37.3c9.46 2.96 19.49-1.99 22.61-11.15 7.57-22.23 15.78-44.96 24.69-68.11a1857.763 1857.763 0 0 1 62.98-145l-196.63-61.4a1696.48 1696.48 0 0 1-28.22 157.86c-5.4 23.66-11.15 46.55-17.17 68.65-2.52 9.26 2.91 18.92 12.3 21.85Z"
          className="cls-teq35"
        />
        <path
          d="M470.74 1634.11c-.52 2.46-1.05 4.92-1.58 7.39a1703.132 1703.132 0 0 1-21.21 86.81c-2.52 9.26 2.91 18.92 12.3 21.85l119.44 37.3c9.46 2.96 19.49-1.99 22.61-11.14a1848.743 1848.743 0 0 1 30.19-82.23c1.32-3.35 2.64-6.68 3.98-10-11.62-10.46-29.88-23.68-54.66-28.86-15.97-3.34-24.77-1.26-43.04-2.72-16.41-1.31-39.86-5.41-68.04-18.39Z"
          className="cls-teq39"
        />
        <ellipse
          cx={592.03}
          cy={1532.62}
          className="cls-teq311"
          rx={18.95}
          ry={110.74}
          transform="rotate(-72.66 592.001 1532.603)"
        />
        <ellipse
          cx={592.25}
          cy={1530.6}
          className="cls-teq35"
          rx={14.51}
          ry={105.3}
          transform="rotate(-72.66 592.225 1530.588)"
        />
        <path
          d="M471.19 1633.03c-.81 1.48-.28 3.3.21 4.56 5.2 13.43 31.69 32.53 75.57 42.74 19.81 4.61 50.51 9.11 89.24 4.23l9.27-22.47c-1.92-1.3-5.09-3.37-9.19-5.57-34.4-18.51-55.87-5.03-101.91-12.26-33.32-5.23-59.41-18.16-63.19-11.23Z"
          className="cls-teq38"
        />
        <ellipse
          cx={662.65}
          cy={1599.88}
          className="cls-teq310"
          rx={21.16}
          ry={3.79}
          transform="rotate(-65.73 662.618 1599.855)"
        />
        <path
          d="M585.17 1555.05c37.64 11.79 51.7 14.4 51.36 16.11-.45 2.27-26.11 2.08-52.94-6.3-26.83-8.39-48.03-22.84-47.12-24.94.67-1.54 12.93 3.93 48.7 15.14Z"
          className="cls-teq310"
        />
        <ellipse
          cx={535.13}
          cy={1761.82}
          className="cls-teq32"
          rx={7.62}
          ry={44.29}
          transform="rotate(-72.66 535.107 1761.802)"
        />
        <ellipse
          cx={616.02}
          cy={1660.35}
          className="cls-teq34"
          rx={6.46}
          ry={17.34}
          transform="rotate(-72.66 615.993 1660.329)"
        />
        <ellipse
          cx={510.28}
          cy={1655.98}
          className="cls-teq34"
          rx={5.95}
          ry={25.05}
          transform="rotate(-65.73 510.251 1655.954)"
        />
        <path
          d="m536.38 1878.44-140.37 37.57c-11.12 2.98-22.58-3.46-25.84-14.51-7.9-26.82-16.53-54.27-25.94-82.26a2274.533 2274.533 0 0 0-67.33-175.71l231.08-61.84c5.5 59.12 13.94 122.38 26.41 189.02 5.31 28.4 11.08 55.9 17.18 82.48 2.56 11.14-4.15 22.3-15.19 25.25Z"
          className="cls-teq311"
        />
        <path
          d="M380.55 1895.77c-7.93-4.26-13.17-9.99-16.27-13.98 2 6.56 3.95 13.09 5.87 19.59 3.25 11.04 14.71 17.48 25.84 14.51l140.37-37.57c11.04-2.95 17.74-14.12 15.19-25.25-1.9-8.29-3.77-16.67-5.61-25.14.94 6.27 1.31 15.51-3.07 24.44-8 16.33-25.15 18-73.87 31.19-53.33 14.44-69.51 22.37-88.43 12.21Z"
          className="cls-teq31"
        />
        <path
          d="m524.31 1852.84-130.29 34.87c-10.32 2.76-20.91-3.01-23.86-13.01a2006.426 2006.426 0 0 0-84.96-233.39l214.48-57.4c4.76 53.58 12.22 110.89 23.39 171.26 4.76 25.72 9.94 50.63 15.45 74.69 2.31 10.08-3.97 20.25-14.22 22.99Z"
          className="cls-teq35"
        />
        <path
          d="M518.16 1727.4c.45 2.67.91 5.35 1.38 8.03a1814.295 1814.295 0 0 0 18.99 94.42c2.31 10.09-3.97 20.25-14.22 22.99l-130.29 34.87c-10.32 2.76-20.91-3.01-23.86-13-7.17-24.28-15-49.12-23.57-74.44-1.75-5.19-3.52-10.34-5.3-15.45-1.27-3.67-2.55-7.32-3.84-10.95 12.98-10.75 33.23-24.18 60.14-28.66 17.35-2.89 26.73-.26 46.47-1.02 17.73-.68 43.17-4.06 74.09-16.78Z"
          className="cls-teq39"
        />
        <ellipse
          cx={392.04}
          cy={1612.72}
          className="cls-teq311"
          rx={119.36}
          ry={20.43}
          transform="rotate(-14.98 392.148 1613.021)"
        />
        <ellipse
          cx={391.89}
          cy={1610.53}
          className="cls-teq35"
          rx={113.5}
          ry={15.64}
          transform="rotate(-14.98 392.01 1610.837)"
        />
        <path
          d="M517.72 1726.21c.8 1.63.15 3.56-.43 4.9-6.19 14.23-35.57 33.63-83.28 42.68-21.54 4.08-54.8 7.57-96.29.59-2.99-8.2-5.99-16.41-8.98-24.61 2.12-1.32 5.63-3.4 10.14-5.59 37.86-18.41 60.39-2.93 110.3-8.68 36.11-4.16 64.79-16.93 68.55-9.29Z"
          className="cls-teq38"
        />
        <ellipse
          cx={313}
          cy={1682.02}
          className="cls-teq310"
          rx={4.09}
          ry={22.8}
          transform="rotate(-21.91 313.098 1682.26)"
        />
        <path
          d="M398.43 1637.17c-41.06 11.03-56.32 13.21-56.03 15.07.39 2.47 28.02 3.4 57.29-4.44s52.74-22.46 51.85-24.77c-.65-1.69-14.1 3.66-53.12 14.14Z"
          className="cls-teq310"
        />
        <ellipse
          cx={443.15}
          cy={1862.08}
          className="cls-teq32"
          rx={47.74}
          ry={8.21}
          transform="rotate(-14.98 443.27 1862.429)"
        />
        <ellipse
          cx={360.54}
          cy={1749.21}
          className="cls-teq34"
          rx={18.69}
          ry={6.96}
          transform="rotate(-14.98 360.658 1749.549)"
        />
        <ellipse
          cx={474.6}
          cy={1749.2}
          className="cls-teq34"
          rx={27}
          ry={6.42}
          transform="rotate(-21.91 474.713 1749.453)"
        />
        {children}
      </g>
    </svg>
  );
}
